import React from 'react';
import { mockData } from '../mock';

const HeroFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center">
          <p className="text-xs text-gray-500 font-light">
            © {new Date().getFullYear()} Rrammy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default HeroFooter;